import { RouteObject, useRoutes } from "react-router";
import { useAppConfig } from "@ct-react/core";
import { ArticleType } from "@shared/url";
import { allLocales } from "@shared/locale";
import { ProtectedOutlet } from "./bundles/client-ui";
import HomePage from "./pages/home";
import SearchPage from "./pages/search";
import OpenArticlePage from "./pages/open-article";
import NotFoundPage from "./pages/not-found";
import CartPage from "./pages/checkout/cart";
import CheckoutOutlet from "./pages/checkout/outlet";
import InformationPage from "./pages/checkout/information";
import PaymentPage from "./pages/checkout/payment";
import CallbackPage from "./pages/checkout/callback";
import ProfilePage from "./pages/me/profile";
import Useful_info from "./pages/useful-info";
import Contact from "./pages/contact";
import Wishlist from "./pages/wishlist";

export const routesConfig = (withLogin: boolean = false): RouteObject[] => ([
  {
    element: <HomePage />,
    index: true,
    data: { search: { displayable: false } }
  },
  {
    path: "rentals",
    children: [
      {
        path: "short",
        children: [
          {
            path: "",
            index: true,
            element: <SearchPage type={ArticleType.RENTAL} />,
            data: { search: { withSearchParams: ArticleType.RENTAL, targeted: true } },
          },
          {
            path: ":slug",
            element: <OpenArticlePage />,
            data: { search: { displayable: false } }
          }
        ]
      },
      {
        path: "seasonally",
        children: [
          {
            path: "",
            index: true,
            element: <SearchPage type={ArticleType.SEASONAL} />,
            data: { search: { withSearchParams: ArticleType.SEASONAL, targeted: true } },
          },
          {
            path: ":slug",
            element: <OpenArticlePage />,
            data: { search: { displayable: false } }
          }
        ]
      },
      {
        path: "annually",
        children: [
          {
            path: "",
            index: true,
            element: <SearchPage type={ArticleType.ANNUAL} />,
            data: { search: { withSearchParams: ArticleType.ANNUAL, targeted: true } },
          },
          {
            path: ":slug",
            element: <OpenArticlePage />,
            data: { search: { displayable: false } }
          }
        ]
      }
    ]
  },
  {
    path: "purchases",
    children: [
      {
        path: "",
        index: true,
        element: <SearchPage type={ArticleType.SALE} />,
        data: { search: { withSearchParams: ArticleType.SALE, targeted: true } },
      },
      {
        path: ":slug",
        element: <OpenArticlePage />,
        data: { search: { displayable: false } }
      }
    ]
  },
  {
    path: "checkout",
    element: <CheckoutOutlet />,
    data: { search: { displayable: false } },
    children: [
      {
        path: "",
        index: true,
        element: <CartPage />
      },
      {
        path: "information",
        element: <InformationPage />
      },
      {
        path: "payment",
        children: [
          {
            path: "",
            index: true,
            element: <PaymentPage />
          },
          {
            path: "success",
            element: <CallbackPage succeeded={true} />
          },
          {
            path: "cancellation",
            element: <CallbackPage succeeded={false} />
          }
        ]
      }
    ]
  },
  {
    path:"useful-info",
    element: <Useful_info />,
    data: { search: { displayable: false } }
  },
  {
    path:"contact",
    element: <Contact/>,
    data: { search: { displayable: false } }
  },
  ...(!withLogin ? [] : [
    {
      path: "me",
      element: <ProtectedOutlet />,
      data: { search: { displayable: false } },
      children: [
        {
          path: "profile",
          index: true,
          element: <ProfilePage />
        }
      ]
    }
  ]),
  {
    path: "wishlist",
    element: <Wishlist/>,
    data: { search: { displayable: false } }
  },
  {
    path: "*",
    element: <NotFoundPage />,
    data: { search: { displayable: false } }
  }
]);

const LocaleRoutes = () => {

  const { options: { withLogin } } = useAppConfig();

  return useRoutes([
    ...allLocales.map(locale => ({
      path: locale.basename,
      children: routesConfig(withLogin) as RouteObject[]
    }))
  ]);

}

export default LocaleRoutes;
